import React, { useRef, useState, useEffect } from 'react';
import { Logo } from 'components/logo/Logo';
import { Grid } from 'components/grid/Grid';

import { useWindowSize } from 'hooks/useWindowSize';
import { isDesktopWidth } from 'utils/helpers';

import style from './MainFooter.module.scss';

export type MainFooterType = {
  location: 'home' | 'contact' | 'footer';
};

export const MainFooter = (props: MainFooterType): JSX.Element => {
  const {location} = props
  const listenerRef = useRef<HTMLDivElement>(null);
  const rectRef = useRef<HTMLDivElement>(null);
  const renderGrid = !['home'].includes(location);
  const windowSize = useWindowSize();
  const [isDesktop, setIsDesktop] = useState<boolean>(false);
  const renderPlaceholder = !['home'].includes(location)

  useEffect(() => {
    const desktop = isDesktopWidth(windowSize.width);
    setIsDesktop(desktop);
  }, [windowSize.width]);

  return (
    <footer className={`${style.container} ${style[location]}`} ref={listenerRef}>
      { renderGrid ? <Grid reverse={true} /> : null }
      { renderPlaceholder && isDesktop ? <div className={style.placeholder}></div> : null}
      <div className={style.rect} ref={rectRef}>
        <Logo
          listenerRef={listenerRef}
          rectRef={rectRef}
          location={location}
        />
      </div>

      <div className={style.overscroll}></div>
    </footer>
  );
};
